import { ReactNode } from 'react';
import { Text } from '@mantine/core';

type TouringCardTitlePropsType = {
  children: ReactNode;
};

export const TouringCardTitle: React.FC<TouringCardTitlePropsType> = ({
  children,
}) => {
  return <Text truncate>{children}</Text>;
};
